import React from 'react';

const About = () => {
    return (
        <div>
            <h1>THis is all about our page</h1>
        </div>
    );
};

export default About;